import { Box, Image, Heading, useBreakpointValue, Text, Link } from "@chakra-ui/react";
import { MSATPassedVector } from "../../assets/images";
import { Share } from "../../assets/icons/components/SocialMedia/Share";
import useCleverTap, {
  CleverTapEvents,
  ModalNames,
  ScreenNames,
} from "../../clevertap/useCleverTap";
import { NotFound } from "../../assets/images";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
const ShareModal = ({ certificateUrl, name }: { certificateUrl: string; name?: string }) => {
  const headingSize = useBreakpointValue<"h5" | "h4">({
    base: "h5",
    md: "h4",
  });
  const clevertap = useCleverTap()[0];
  const params = useParams() as { applicantID: string };
  const ogUrl = `${process.env.REACT_APP_BASE_URL}/certificates/${params.applicantID}`;
  useEffect((): void => {
    clevertap.fireEvent(CleverTapEvents.viewed_modal, {
      modal_name: ModalNames.msatSuccess,
    });
  }, []);
  return (
    <Box
      borderRadius={"ms-16"}
      bgImage={MSATPassedVector}
      bgRepeat={"no-repeat"}
      pt={{ base: "40px", md: "48px" }}
      pb={{ base: "8px", md: "16px" }}
      px={{ base: "24px", md: "54px" }}
      m={"-24px"}
    >
      <Box textAlign={"center"}>
        <Heading as={"h5"} color={"ms-blue.500"} mb={"ms-16"}>
          Congrats {name} !
        </Heading>
        <Heading as={headingSize} mb={{ base: "16px", md: "24px" }}>
          You have successfully completed <br />
          The Masai School Admission Test (MSAT)
        </Heading>
        <Image
          mx={"auto"}
          src={certificateUrl ? certificateUrl : NotFound}
          alt="admit card certificate not found"
          mb={{ base: "0px", md: "ms-4" }}
        />
        {certificateUrl ? (
          <Share
            linkedInUrl={ogUrl}
            facebookUrl={ogUrl}
            twitterUrl={ogUrl}
            copyUrl={ogUrl}
            title="Successfully completed the Masai School Admission Test (MSAT)"
            hashtag="#masaischool #msat"
            screen_name={ScreenNames.msatSuccess}
          />
        ) : (
          <Text textStyle="body1" mb={"32px"} color={"ms-grey.700"}>
            Provisional Admit Card not found, please retry after sometime or reach out to us at{" "}
            <Link
              cursor={"pointer"}
              isExternal={true}
              href="mailto:admissions@masaischool.com"
              color="ms-blue.500"
              textDecoration={"underline"}
              onClick={() => {
                clevertap.fireEvent(CleverTapEvents.click_contact_us, {
                  screen_name: ScreenNames.msatSuccess,
                  button_text: "admissions@masaischool.com",
                  button_type: "link",
                });
              }}
            >
              admissions@masaischool.com
            </Link>
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default ShareModal;
